import { templateJitUrl } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { Message, MessagesResponse, MsgsService, Template } from 'generated-sources/openapi';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {
  showTable = true;
  showForm = false;
  adding = true;
  sort: string;
  dir = 'asc';
  _limit = 50;
  _page = 0;

  templates: Template[] = [];
  editMsg: any = { template_id: 1 };

  messagesResponse$ = new BehaviorSubject<MessagesResponse>(null);
  messages$ = this.messagesResponse$.pipe(map((resp) => {
    return resp.data;
  }))
  templates$: Observable<Template[]>;

  constructor(private messageService: MsgsService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.templates$ = this.messageService.msgsTemplatesGet();
    this.load().then(() => {
      // TODO:
    }, this.reportError.bind(this))
  }

  reportError(e: any) {
    console.error(e);
  }

  sortChanged(opts: Sort) {
    this.sort = opts.active;
    this.dir = opts.direction;

    this.load(this._limit, this._page, this.sort, this.dir).then(() => {
      // todo:
    }, this.reportError.bind(this));
  }

  async loadTemplates() {
  }

  async load(limit = 50, page = 0, sort: string = null, dir = 'asc') {
    this._limit = limit;
    this._page = page;
    const msgs = await this.messageService.msgsPagedGet(page, limit, sort, dir).toPromise();
    this.messagesResponse$.next(msgs);
  }

  templateName(templates: Template[], id: number) {
    return templates.find(v => v.id === id).name;
  }

  startNew() {
    this.editMsg = { template_id: 1, name: '', phone: '' };
    this.showForm = true;
    this.showTable = false;
    this.adding = true;
  }

  edit(obj) { }

  cancel() {
    this.showForm = false;
    this.showTable = true;
    this.adding = false;
  }

  save() {
    this.messageService.msgsPut(this.editMsg).toPromise().then((r) => {
      console.log(r);
      this.showTable = true;
      this.showForm = false;
      this.editMsg = null;
      // TODO: Reload
      return this.load();
    }, (err) => {
      this._snackBar.open(err?.error || 'Error with message/phone', null, {
        duration: 5000,
      });
      console.error(err);
    }).then(() => { }, this.reportError.bind(this));
  }

  onPageChange(event) {
    console.log('onPageChange', event);
    this.load(event.pageSize, event.pageIndex, this.sort, this.dir).then(() => { }, this.reportError.bind(this));
  }

}
